import React from "react";
import PFlogo from "images/logo-dark.png";
import loginBackground from "images/login/loginBackground.svg";

import styles from "./styles.module.scss";

export const starterPlanIntegrations = () => {

  return (
    <>
    <div className={styles.content}>
        <div className={styles.container}>
        <img alt="Paperflite Logo" className={styles.logo} src={PFlogo} />
        </div>
        <h1 className={styles.heading}>Houston, we have a (tiny) problem!</h1>
        <p className={styles.description}>
            It looks like your team’s on the Starter plan, so the Chrome extension isn’t available just yet.</p>
        <p className={styles.subText}> Upgrade your plan to get onboard.</p>
        
        <a href="https://www.paperflite.com/pricing" target="_blank" className={styles.button}> Get the extension now! </a>
        <img
          alt="Half head man with audio waves in the background"
          className={styles.backgroundImage}
          src={loginBackground}
        />
      </div>
    </>
  );
};

export default starterPlanIntegrations;
